import { evaluateXpath } from '../interruptibleXpath'

export function getInputElementGivenLabel(rootNode: Node, label: string) {
  // Get label
  const labelElement = evaluateXpath<HTMLLabelElement>(
    rootNode,
    `descendant-or-self::label[contains(text(), "${label}") or text() = "${label}"]`,
  )[0]

  if (!labelElement) {
    throw new Error(`Could not find label "${label}"`)
  }

  // Try using "get element by id"; else look for nearest input or select
  let inputElement = document.getElementById(
    labelElement.htmlFor,
  ) as HTMLInputElement

  if (!inputElement) {
    inputElement = evaluateXpath<HTMLInputElement>(
      labelElement,
      'ancestor::*/descendant::input',
    )[0]
  }

  if (!inputElement || !(inputElement instanceof HTMLInputElement)) {
    throw new Error(`Could not find input element for label "${label}"`)
  }

  return inputElement
}

export function getSelectElementGivenLabel(rootNode: Node, label: string) {
  // Get label
  const labelElement = evaluateXpath<HTMLLabelElement>(
    rootNode,
    `descendant-or-self::label[contains(text(), "${label}") or text() = "${label}"]`,
  )[0]

  if (!labelElement) {
    throw new Error(`Could not find label "${label}"`)
  }

  // Try using "get element by id"; else look for nearest input or select
  let selectElement = document.getElementById(
    labelElement.htmlFor,
  ) as HTMLSelectElement

  if (!selectElement) {
    selectElement = evaluateXpath<HTMLSelectElement>(
      labelElement,
      'ancestor::*/descendant::select',
    )[0]
  }

  if (!selectElement || !(selectElement instanceof HTMLSelectElement)) {
    throw new Error(`Could not find select element for label "${label}"`)
  }

  return selectElement
}
